import { enrollmentsApis, videoApis } from '@shared/apis';
import { genericMutationWithId, genericQueryWithId } from './generics';

export const useGetMeetingDetails = genericQueryWithId<videoApis.GetWaitingScreenMeetingDetails>(
  videoApis.getWaitingScreenMeetingDetails
);

export const useGetHasMentorEntered = genericQueryWithId<videoApis.GetHasMentorEntered>(
  videoApis.getHasMentorEntered
);

export const useStartMeeting = genericMutationWithId<videoApis.StartMeeting>(
  videoApis.startMeeting
);

export const useEndMeeting = genericMutationWithId<videoApis.EndMeeting>(
  videoApis.endMeeting,
  enrollmentsApis.getActiveStudentsByMentor.endpoint,
  enrollmentsApis.searchMentorEnrollments.endpoint,
  enrollmentsApis.searchSessionHistory.endpoint
);

export const useGetNoShowPreview = genericQueryWithId<videoApis.GetNoShowPreview>(
  videoApis.getNoShowPreview
);
